// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>45</span>&nbsp;&nbsp;Nevertheless, he saw their adversity,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;when he heard their lamentation.<br> </p> </div></div>";
// Exports
module.exports = code;